import MuiDialog from './muiDialog'
export default MuiDialog
